import type { ScreenModule } from "../../../app/screen-module";
import { TenantDetailPage } from "../pages";

export default {
	id: "system-admin.tenant-detail",
	path: "/system/tenants/:tenantId",
	area: "system-admin",
	label: "テナント詳細",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantDetailPage,
} satisfies ScreenModule;
